import React, { memo, useCallback, useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import { useMutation } from '@apollo/react-hooks'
import { Select, MenuItem } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { useTranslation } from 'react-i18next'
import DeleteIcon from '@material-ui/icons/DeleteOutlineOutlined'
import Chip from '@material-ui/core/Chip'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

import styles from './styles'
import { Card, CardContent, TextField } from '@material-ui/core'
import { CompanyOffices, DeleteCompanyOffice } from 'store'
import { useParams } from 'react-router-dom'
import {
	useHandleCompanyOfficesMutation,
	useInsertIntoCompanyOfficesCollectionMutation,
	useRoLocationsCollectionQuery,
} from 'graphql/__generated__/graphql'

const useStyles = makeStyles(styles)

const Address: React.FunctionComponent<any> = props => {
	const { companyOffice, deleteEmptyOfficeAddress, regions } = props
	const companyOfficeId = (companyOffice && companyOffice.id) || undefined
	const params: any = useParams()
	const classes = useStyles()
	const { t } = useTranslation()
	const [editView, setView] = React.useState(false)

	const [streetName, setStreetName] = React.useState(
		(companyOffice && companyOffice.address) || '',
	)
	const [zipCode, setZipCode] = React.useState(
		(companyOffice && companyOffice.zipCode) || '',
	)
	const [confirmDelete, setConfirmDelete] = useState(false)
	const [openDeleteModal, setOpenDeleteModal] = useState(false)

	const [deleteCompanyOfficeMutation] = useMutation(DeleteCompanyOffice, {
		update(cache, { data: { deleteCompanyOffice } }) {
			const query = CompanyOffices
			try {
				cache.writeQuery({
					query,
					variables: { companySlug: params.companySlug },
					data: { companyOffices: deleteCompanyOffice.offices },
				})
			} catch (error) {
				console.error(error)
			}
		},
	})
	const [region, setRegion] = useState<string | undefined>(
		companyOffice && companyOffice.location
			? companyOffice.location.region2
			: undefined,
	)

	const [locationId, setLocationId] = useState<string | undefined>(
		companyOffice && companyOffice.location
			? companyOffice &&
					companyOffice.location &&
					companyOffice.location.id
			: undefined,
	)

	const [errorFields, setErrorFields] = useState({
		region: false,
		location: false,
	})

	let showAddress = `${streetName ? streetName + ', ' : ''} 
	${zipCode ? zipCode + ', ' : ''}  
		${companyOffice ? companyOffice.location.name + ', ' : ''} 
		${companyOffice ? companyOffice.location.region2 : ''}  
	`

	const toggleConfirmDelete = useCallback(() => {
		setConfirmDelete(confirmDelete => !confirmDelete)
	}, [])
	const toggleDeleteModal = useCallback(() => {
		setOpenDeleteModal(openDeleteModal => !openDeleteModal)
	}, [])
	const [
		updateMutationHandle,
		// { loading: updateMutationLoading },
	] = useHandleCompanyOfficesMutation()

	// Todo Kundan1023
	// Please check the payload
	const [addCompanyOfficeMutation] =
		useInsertIntoCompanyOfficesCollectionMutation({
			update(cache, { data }) {
				const query = CompanyOffices
				try {
					cache.writeQuery({
						query,
						variables: {
							companySlug: params.companySlug,
						},
						data: {
							companyOffices:
								data?.insertIntoCompanyOfficesCollection,
						},
					})
				} catch (error) {
					console.error(error)
				}
			},
		})

	const { data: locations } = useRoLocationsCollectionQuery({
		skip: !region,
		variables: {
			data: {
				not: {
					type: {
						in: ['Judeţe'],
					},
				},
				region2: { ilike: region },
				// type_not_in: ['Judeţe'],
			},
		},
	})
	const handleRegionChange = useCallback(
		(event: any) => {
			setErrorFields({
				...errorFields,
				region: false,
			})
			setRegion(event.target.value)
		},
		[errorFields],
	)

	const handleLocationChange = useCallback(
		(event: any) => {
			setErrorFields({
				...errorFields,
				location: false,
			})
			setLocationId(event.target.value)
		},
		[errorFields],
	)

	const save = useCallback(async () => {
		let result: any
		if (companyOfficeId) {
			result = await updateMutationHandle({
				variables: {
					data: {
						id: companyOfficeId,
						// Todo missing key: companySlug
						// companySlug: params.companySlug,
						address: streetName,
						location: locationId,
						zipCode,
					},
				},
			})
		} else {
			result = await addCompanyOfficeMutation({
				variables: {
					data: {
						id: companyOfficeId,
						// Todo missing key: companySlug
						// companySlug: params.companySlug,
						address: streetName,
						location: locationId,
						zipCode,
					},
				},
			})
		}

		// delete empty card address
		if (result && result.data && !companyOfficeId) {
			deleteEmptyOfficeAddress()
		}
	}, [
		addCompanyOfficeMutation,
		companyOfficeId,
		locationId,
		streetName,
		updateMutationHandle,
		zipCode,
		deleteEmptyOfficeAddress,
	])

	const handleClick = useCallback(
		(editView: boolean) => {
			if (!editView) {
				if (!region || !locationId) {
					setErrorFields({
						region: !region,
						location: !locationId,
					})
					return
				}
				save()
			}
			setView(editView)
		},
		[save, locationId, region],
	)

	const updateStreetName = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			setStreetName(e.target.value)
		},
		[],
	)
	const updateZipCode = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			setZipCode(e.target.value)
		},
		[],
	)

	useEffect(() => {
		if (confirmDelete) {
			const mutate = async () => {
				try {
					if (companyOfficeId) {
						await deleteCompanyOfficeMutation({
							variables: {
								id: companyOfficeId,
							},
						})
					} else {
						deleteEmptyOfficeAddress()
					}
				} catch (error) {
					console.error(error)
				}
			}
			mutate()
			setConfirmDelete(false)
			setOpenDeleteModal(false)
		}
	}, [
		confirmDelete,
		deleteCompanyOfficeMutation,
		deleteEmptyOfficeAddress,
		companyOfficeId,
	])

	return (
		<>
			<Grid item className={classes.addressCardWrap}>
				<Card className={classes.cardRoot}>
					<CardContent>
						<div className={classes.titleSection}>
							<span className={classes.title}>
								{t('Business Identity')}
							</span>
							<span
								className={classes.actionTitle}
								onClick={() => handleClick(!editView)}
							>
								{!editView ? 'Edit' : 'Done'}
							</span>
							<Chip
								onClick={toggleDeleteModal}
								style={{ margin: 2, background: '#fff' }}
								icon={<DeleteIcon />}
								variant="outlined"
								color={'secondary'}
								clickable={true}
								classes={{
									label: classes.editIconLabel,
								}}
							/>
						</div>
						<div className={classes.cardDescription}>
							<div
								className={
									!editView
										? classes.displayBlock
										: classes.displayNone
								}
							>
								<span className={classes.labelTextField}>
									{t('Address')}
								</span>
								<span className={classes.addressInfo}>
									{showAddress}
								</span>
							</div>
							<div
								className={
									editView
										? classes.displayBlock
										: classes.displayNone
								}
							>
								<Grid container spacing={4}>
									<Grid item xs={12} sm={6}>
										<TextField
											label={'Street'}
											value={streetName}
											placeholder={'Street'}
											className={classes.textField}
											InputLabelProps={{
												className:
													classes.labelTextField,
											}}
											InputProps={{
												className: classes.input,
											}}
											margin="normal"
											onChange={updateStreetName}
											fullWidth
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<FormControl
											className={classes.formControl}
										>
											<InputLabel
												htmlFor="region"
												error={errorFields.region}
											>
												{`${t('Region')}*`}
											</InputLabel>
											<Select
												value={region ? region : ''}
												onChange={handleRegionChange}
												inputProps={{
													name: `${t('Region')}*`,
													id: 'region',
												}}
												error={errorFields.region}
											>
												{regions &&
													regions?.roLocations &&
													regions?.roLocations?.map(
														(item: any) => {
															return (
																<MenuItem
																	key={
																		item.id
																	}
																	value={
																		item.name
																	}
																>
																	{item.name}
																</MenuItem>
															)
														},
													)}
											</Select>
										</FormControl>
									</Grid>

									<Grid item xs={12} sm={6}>
										<FormControl
											className={classes.formControl}
										>
											<InputLabel
												htmlFor="location"
												error={errorFields.location}
											>
												{`${t('Location')}*`}
											</InputLabel>
											<Select
												value={
													locationId ? locationId : ''
												}
												disabled={!region}
												onChange={handleLocationChange}
												inputProps={{
													name: `${t('Location')}*`,
													id: 'location',
												}}
												error={errorFields.location}
											>
												{locations &&
													locations
														?.roLocationsCollection
														?.edges &&
													locations?.roLocationsCollection?.edges?.map(
														item => {
															return (
																<MenuItem
																	key={
																		item
																			.node
																			.id
																	}
																	value={
																		item
																			.node
																			.id
																	}
																>
																	{
																		item
																			.node
																			.name
																	}
																</MenuItem>
															)
														},
													)}
											</Select>
										</FormControl>
									</Grid>
									<Grid item xs={6}>
										<TextField
											label={'Zip code'}
											value={zipCode}
											placeholder={'State'}
											className={classes.textField}
											InputLabelProps={{
												className:
													classes.labelTextField,
											}}
											InputProps={{
												className: classes.input,
											}}
											margin="normal"
											onChange={updateZipCode}
											fullWidth
										/>
									</Grid>
								</Grid>
							</div>
						</div>
					</CardContent>
				</Card>
			</Grid>
			{/* </Fade> */}
			<Dialog
				open={openDeleteModal}
				onClose={toggleDeleteModal}
				aria-labelledby="responsive-dialog-title"
				disableEscapeKeyDown
				disableBackdropClick
			>
				<DialogTitle id="responsive-dialog-title">
					{companyOffice && companyOffice.hq
						? t(
								'Please select another headquarters before delete this office address',
						  )
						: t(
								'Are you sure you want to delete this office address?',
						  )}
				</DialogTitle>
				<DialogActions>
					{companyOffice && companyOffice.hq ? (
						<Button
							color="primary"
							autoFocus
							onClick={toggleDeleteModal}
						>
							{t('Ok')}
						</Button>
					) : (
						<>
							<Button
								color="primary"
								onClick={toggleConfirmDelete}
							>
								{t('Yes')}
							</Button>
							<Button
								color="primary"
								autoFocus
								onClick={toggleDeleteModal}
							>
								{t('No')}
							</Button>
						</>
					)}
				</DialogActions>
			</Dialog>
		</>
	)
}

export default memo(Address)
